module.exports = __webpack_public_path__ + "new_name_sharp_right.svg?0bd06c3c09fdbb084a877cf48d43b814";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/new_name_sharp_right.svg
// module id = 185
// module chunks = 0